const normalize = (value) => (value || "").trim().toLowerCase();

const isLocalhost = () => {
  const hostname = window.location.hostname;

  return (
    hostname === "localhost" ||
    hostname === "[::1]" ||
    hostname.endsWith(".localhost") ||
    /^127(?:\.\d+){3}$/.test(hostname)
  );
};

const readAppEnv = () =>
  normalize(process.env.REACT_APP_APP_ENV || process.env.REACT_APP_ENV);

const readApiUrl = () => normalize(process.env.REACT_APP_API_URL);

const isStageHostname = () => {
  const hostname = normalize(window.location.hostname);

  return hostname.includes(".stage.") || hostname.startsWith("stage.");
};

const isProdHostname = () => {
  const hostname = normalize(window.location.hostname);

  return (
    hostname === "admin.noodlz.com" || hostname.endsWith(".prod.noodlz.com")
  );
};

const isProdApiUrl = () => {
  const apiUrl = readApiUrl();

  return (
    Boolean(apiUrl) &&
    apiUrl.includes("prod") &&
    !apiUrl.includes("stage") &&
    !apiUrl.includes("localhost") &&
    !apiUrl.includes("127.0.0.1")
  );
};

/**
 * Performance Monitoring is available on localhost and stage only.
 *
 * Stage SSM uses REACT_APP_APP_ENV=development (same as local dev).
 * Prod should use REACT_APP_APP_ENV=production.
 */
export const isPerformanceMonitoringEnabled = () => {
  const deployment = normalize(process.env.REACT_APP_DEPLOYMENT_ENV);
  if (deployment === "stage-v2") return true;
  if (deployment === "prod-v2") return false;

  if (isLocalhost()) {
    return true;
  }

  const appEnv = readAppEnv();

  if (["prod", "production"].includes(appEnv)) {
    return false;
  }

  // Stage builds use `development` in /stage/admin SSM.
  if (["development", "dev", "stage", "staging"].includes(appEnv)) {
    return true;
  }

  if (isStageHostname()) {
    return true;
  }

  const apiUrl = readApiUrl();

  if (
    apiUrl.includes(".stage.") ||
    apiUrl.includes("localhost") ||
    apiUrl.includes("127.0.0.1")
  ) {
    return true;
  }

  if (isProdApiUrl() || isProdHostname()) {
    return false;
  }

  return false;
};
